import axios from "axios"

const fetchMostViewedRequest = () => {
	return {type: "FETCH_MOSTVIEWED_REQUEST"}
}

const fetchMostViewedSuccess = (most_viewed) => {
	return {type: "FETCH_MOSTVIEWED_SUCCESS", payload: most_viewed}
}

const fetchMostViewedFailure = (error) => {
	return {type: "FETCH_MOSTVIEWED_FAILURE", payload: error}
}

export const fetchMostViewed = () => {
	return (dispatch) => {
		dispatch(fetchMostViewedRequest())
		axios.get("p/profile-list/view-count")
		.then(response => {
			const most_viewed = response.data
			dispatch(fetchMostViewedSuccess(most_viewed))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchMostViewedFailure(error))	
		})
	}
}